import { http, HttpResponse } from 'msw';
import { MOCK } from './mocks';

const refundable = [
  http.get(`${process.env.BFF_URL}freights/:encodedFreightId/truckers/refundable-fare`, () =>
    HttpResponse.json({
      data: {
        truckers: MOCK,
        metadata: {
          freight: {
            identifiers: {
              id: 'encoded',
              code: 'SPMG-8CDF',
            },
            origin: {
              stateAbbreviation: 'SP',
            },
            destination: {
              stateAbbreviation: 'MG',
            },
          },
        },
      },
    })
  ),
];

export { refundable };
